module.exports = "/packs/media/images/meeting_1-ba818db0bf8895713c5b60b877ae916c.jpg";